import styled from "styled-components";

export const StyledPrivMainDiv = styled.div`
  font-size: 16px;
  margin: 20px;
  li{
    list-style-type: circle;
  }
`;